import { Component } from 'react'
import ReactDOM from 'react-dom'
import { observer } from 'mobx-react'

import * as h from 'h'

import { Spinner } from 'components/ResultsIndicator'

import cloud from 'd3-cloud'
import { select } from 'd3-selection'
import { scaleLinear, schemeCategory10 } from 'd3-scale'

@observer
export default class KeywordCloud extends Component {
  componentDidMount () {
    setTimeout(() => this.initCloud(this.props), this.props.renderDelay)
  }

  componentWillReceiveProps (newProps) {
    if (this.props.name === newProps.name) {
      return
    }
    this.initCloud(newProps)
  }

  initCloud (props) {
    const { height, keywords } = props
    const width = ReactDOM.findDOMNode(this.refs.container).offsetWidth

    const minScore = Math.min(...keywords.map(w => w.score))
    const maxScore = Math.max(...keywords.map(w => w.score))
    const fontSize = scaleLinear().domain([minScore, maxScore]).range([16, 32])

    cloud()
      .size([width, height])
      .words(keywords.map(d => ({ text: d.kw_str, score: d.score })))
      .rotate(0)
      .padding(4.5)
      .fontSize(d => fontSize(d.score))
      .on('end', words => this.drawCloud(words, props))
      .start()
  }

  drawCloud (words, props) {
    const { height } = props
    const width = ReactDOM.findDOMNode(this.refs.container).offsetWidth

    var fill = schemeCategory10

    var container = select('.' + this.props.theme.container)

    // empty the container (there may be a previously rendered cloud there)
    container.selectAll('*').remove()

    container
      .append('svg')
        .attr('width', width)
        .attr('height', height)
      .append('g')
        .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')
      .selectAll('text')
        .data(words)
      .enter()
        .append('text')
          .style('font-size', d => d.size - 1 + 'px')
          .style('font-family', 'Lato')
          .style('font-weight', '600')
          .style('fill', (d, i) => fill[i % fill.length])
          .attr('text-anchor', 'middle')
          .attr('transform', d => `translate(${d.x}, ${d.y})`)
          .text(d => d.text)
  }

  render () {
    return h.div({ ...h.ca(this.props.theme.container), ref: 'container' },
      h.h(Spinner)
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/KeywordCloud/index.js